const SESSION_ID_STORAGE_KEY = "datalayer-session-id"

export abstract class SessionIdManager {
    protected sessionId: string | null = null

    constructor() {
        this.sessionId = this.getSessionId() || this.generateSessionId()
    }

    /**
     * Generates a unique session ID by combining a UUID and the current timestamp. Store it in sessionStorage in client side only.
     * Return the generated session ID.
     */
    private generateSessionId() {
        const timestamp = Date.now()
        const uuid = crypto.randomUUID()

        const sessionId = `${uuid}-${timestamp}`

        if (typeof window !== "undefined" && typeof sessionStorage !== "undefined") {
            sessionStorage.setItem(SESSION_ID_STORAGE_KEY, sessionId)
        }

        return sessionId
    }

    /**
     * Retrieves the session ID from sessionStorage in client side only.
     * Return the session ID or null if not found.
     */
    private getSessionId() {
        return typeof window !== "undefined" && typeof sessionStorage !== "undefined"
            ? sessionStorage.getItem(SESSION_ID_STORAGE_KEY)
            : null
    }
}
